import React from 'react';
import { useSelector } from 'react-redux';
import { FocusScroll } from '#/widgets/ui';

import { getModalData } from '#/redux/modules/modal/selectors';
import styles from './InfoModal.scss';
import { TV_CONTENT_MODAL } from '#/utils/navigationHelper';

const { CONTENT_AREA, TV_CONTENT_MODAL_ACTION_BUTTON } = TV_CONTENT_MODAL;
const navMap = {
  CONTENT_AREA: {
    id: CONTENT_AREA,
  },
  ACTION_BUTTON: {
    id: TV_CONTENT_MODAL_ACTION_BUTTON,
  },
};

const InfoModal = () => {
  const { infoMessage } = useSelector(state => getModalData(state));
  const title = 'Info';
  const content = infoMessage;

  return (
    <div className={styles.tv}>
      <h2>{title}</h2>
      <FocusScroll
        nav={{ id: navMap.CONTENT_AREA.id, nextdown: navMap.ACTION_BUTTON.id }}
      >
        {content}
      </FocusScroll>
    </div>
  );
};

export default InfoModal;
